import { SetLoading } from "common/components/Loader/Loader";
import { GetCurrentGamePrefix } from "common/constants/Games";
import { LocalStorageKeys } from "common/constants/StorageKeys";
import { changeUrl } from "common/history";
import React from "react";
import { linkGoogle } from "./api";

export default class LinkGoogle extends React.Component {
	async componentDidMount() {
		SetLoading(true, "Linking Google Account");

		const code = this.props.location.search.substring(6);
		try {
			await linkGoogle(code);
		} catch (error) {}

		SetLoading(false);
		const redirect = localStorage.getItem(LocalStorageKeys.POSTLINKURL);
		if (redirect) {
			localStorage.removeItem(LocalStorageKeys.POSTLINKURL);
			changeUrl(redirect);
		} else {
			const route = GetCurrentGamePrefix();
			changeUrl(route + "/event");
		}
	}

	render() {
		return <></>;
	}
}
